import { useTranslation } from 'react-i18next';
import { isFeatureActive } from '../services/ClaimsHelper';
import { useSelector } from 'react-redux';
import { AppState } from '../store';
import type { IFeatureFlags } from '../../types';

const Disclaimer = () => {
  const featureFlags: IFeatureFlags = useSelector(
    (state: AppState) => state.claimsData.featureFlags
  );
  const { t } = useTranslation();
  const showDisclaimer =
    isFeatureActive(featureFlags.ListPrice) && isFeatureActive(featureFlags.PriceDisclaimer);
  return (
    <>
      {showDisclaimer && (
        <div className="disclaimer">
          <p>{t('disclaimer.promotionalMessage')}</p>
        </div>
      )}
    </>
  );
};

export default Disclaimer;
